var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0419 11.503C13.5324 11.503 14.011 11.2781 14.4896 10.7929L24.8633 0.674556C24.4445 0.224852 23.6429 0 22.4823 0H3.29038C2.26139 0 1.54349 0.201183 1.16061 0.615385L11.6061 10.7929C12.0727 11.2663 12.5633 11.503 13.0419 11.503ZM0.335021 18.2959L8.84215 10.071L0.287161 1.76331C0.0957202 2.08284 0 2.65089 0 3.45562V16.5325C0 17.3728 0.11965 17.9645 0.335021 18.2959ZM25.7009 18.2367C25.9043 17.9172 26 17.3491 26 16.5325V3.45562C26 2.68639 25.9162 2.14201 25.7368 1.83432L17.2536 10.071L25.7009 18.2367ZM3.52968 20H22.7096C23.7386 20 24.4445 19.787 24.8274 19.3965L16.2246 11.0533L15.3751 11.8935C14.6213 12.6154 13.8555 12.9586 13.0419 12.9586C12.2283 12.9586 11.4745 12.6154 10.7207 11.8935L9.85918 11.0533L1.24436 19.4083C1.66314 19.7988 2.4289 20 3.52968 20Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.99e9ddaf2bfd06e2142674ec793ee909.svg";
export { ForwardRef as ReactComponent };